import React, { Component } from 'react';
import { string } from "prop-types";
import './TimesheetEntry.css';

class TimesheetSubheader extends Component {
  static PropTypes = {
    startDate: string
  }

  render() {
    return (
      <tr className="timesheetEntrySubheader">
        <td>Project</td>
        <td>Donor</td>
        {
          [...Array(7)].map((_, i) => {
            let day = new Date(this.props.startDate);
            day.setDate(day.getDate() + i);
            day = day.toISOString().substring(5, 10);
            return <td key={i} className="timesheetEntryDataWD">{day}</td>;
          })
        }
      </tr>
    );
  }
}

export default TimesheetSubheader;


// WEBPACK FOOTER //
// ./src/components/main/timesheet/_common/TimesheetSubheader.js